import React from "react";
import { UseFormReturn } from "react-hook-form";
import { ClienteFormValues } from "../ClienteFormSchema";
import { FormattedTextField } from "@/components/form/FormattedTextField";
import { DateField } from "@/components/form/DateField";
import { SelectField } from "@/components/form/SelectField";
import {
  PipelineFormSection,
  pipelineFieldGridClassCompact,
  usePipelineForm,
} from "@/components/form/PipelineFormContext";

interface FamilyInfoStepProps {
  form: UseFormReturn<ClienteFormValues>;
}

const estadoCivilOptions = [
  { value: "solteiro", label: "Solteiro(a)" },
  { value: "casado", label: "Casado(a)" },
  { value: "divorciado", label: "Divorciado(a)" },
  { value: "viuvo", label: "Viúvo(a)" },
  { value: "uniao_estavel", label: "União Estável" },
];

export function FamilyInfoStep({ form }: FamilyInfoStepProps) {
  const watchEstadoCivil = form.watch("estadoCivil");
  const { isPipeline } = usePipelineForm();
  const gridClass = pipelineFieldGridClassCompact(isPipeline);

  return (
    <PipelineFormSection>
      <div className={gridClass}>
        <FormattedTextField
          form={form}
          name="nomeMae"
          label="Nome da Mãe"
          formatter="texto"
          placeholder="Nome completo"
        />

        <FormattedTextField
          form={form}
          name="nomePai"
          label="Nome do Pai"
          formatter="texto"
          placeholder="Nome completo"
        />

        <SelectField
          form={form}
          name="estadoCivil"
          label="Estado Civil"
          options={estadoCivilOptions}
          placeholder="Selecione"
        />

        {(watchEstadoCivil === "casado" || watchEstadoCivil === "uniao_estavel") && (
          <>
            <FormattedTextField
              form={form}
              name="nomeConjuge"
              label="Nome do Cônjuge"
              formatter="texto"
              placeholder="Nome completo"
            />

            <FormattedTextField
              form={form}
              name="cpfConjuge"
              label="CPF do Cônjuge"
              formatter="cpf"
              placeholder="000.000.000-00"
            />

            <DateField
              form={form}
              name="dataNascimentoConjuge"
              label={isPipeline ? "Nasc. Cônjuge" : "Data de Nascimento do Cônjuge"}
              disableFuture
            />
          </>
        )}
      </div>
    </PipelineFormSection>
  );
}
